/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: '',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(Downloading)',
        download:'Downloading',
        errorDownload: 'Hi hagut un error en la descàrrega.',
        cancelDownload: 'Has cancel·lat la descàrrega.',
        initDownload: 'Please wait while audio tour is downloading',
        endDownload: 'Your tour has been downloaded. Enjoy your visit!',
        retry: 'Reintentar',
        noConnection: 'No tens conexió a internet',
        titleMap: '',
        map: 'Planol.png',
        menuItems: [
            {
                idImages: 60,
                title: '',
                author: '',
                description: '',
                audio: '60.mp3'

            },
            {
                idImages: 61,
                title: '',
                author: '',
                description: '',
                audio: '61.mp3'

            },
            {
                idImages: 1,
                title: '',
                author: '',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3'
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: '',
                author: '',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: '',
                author: '',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: '',
                author: '',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: '',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: '',
                author: '',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: '',
                author: '',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: '',
                author: '',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: '',
                author: '',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: '',
                author: '',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: '',
                author: '',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: '',
                author: '',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: '',
                author: '',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: '',
                author: '',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: '',
                author: '',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: '',
                author: '',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: '',
                author: '',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: '',
                author: '',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: '',
                author: '',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: '',
                author: '',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: '',
                isCredits:true,
                author: '',
                description: 'All rights reserved.<br><br>Images and recordings provided by the Agència Catalana del Patrimoni Cultural.<br><br>Photographs: Pepo Segura. Additional photographs: Sònia Martí Recasens.<br><br>Script: José Miguel Torrente.<br><br>Original audio production: Flexiguía.<br><br>Design and development: Trama Media.<br><br>Project management: Àrea de Monuments i Jaciments (AcdPC – Departament de Cultura).<br><br>',
                audio: '',
                idCreditImage: 22,
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/français.js